import { IconButton, Tooltip } from "@mui/material";
import WrapIf from "src/components/utils/WrapIf/WrapIf";
import ArrowIcon from "../../../ArrowIcon/ArrowIcon";
import type { PrevNextPaginatorButtonSlotProps } from "../../PrevNextPaginator.types";

const DEFAULT_ICON_SIZE = 20;

type PrevNextPaginatorButtonProps = {
  direction: "prev" | "next";
  disabled: boolean;
  onClick: () => void;
  iconSize?: number;
  slotProps?: PrevNextPaginatorButtonSlotProps;
};

const PrevNextPaginatorButton = ({
  direction,
  disabled,
  onClick,
  iconSize = DEFAULT_ICON_SIZE,
  slotProps,
}: PrevNextPaginatorButtonProps) => (
  <WrapIf
    condition={!!slotProps?.tooltip}
    With={Tooltip}
    {...slotProps?.tooltip}
    title={slotProps?.tooltip?.title ?? ""}
    arrow
  >
    {/* span: Tooltip still works when IconButton is disabled */}
    <span className="inline-flex">
      <IconButton
        className="group/arrow"
        disabled={disabled}
        onClick={onClick}
        {...slotProps?.iconButton}
      >
        <ArrowIcon
          left={direction === "prev"}
          right={direction === "next"}
          size={iconSize}
          color="inherit"
        />
      </IconButton>
    </span>
  </WrapIf>
);

export default PrevNextPaginatorButton;
